import React from 'react';
import Link from 'gatsby-link';
import Contact from '../Contact';
import './links.scss';

const ContactButton = (props) => (
  <button className="hero-links__link" onClick={props.onClick}>
    <span>Kontakt</span>
  </button>
)

const HeroLinks = () => {
  return (
    <div className="hero-links">
      <div className="hero-links__wrapper">      
        <Link to="/o-nas" className="hero-links__link">O nas</Link>
        <Link to="/oferta" className="hero-links__link">Oferta</Link>
        <Contact element={ContactButton} className="hero-links__link" />
      </div>
    </div>
  )
};

export default HeroLinks;



// WEBPACK FOOTER //
// ./src/components/Hero/HeroLinks.js